export interface ImageModelVersion {
  ref: string;
  name: string;
  imageUrl?: string;
}

export interface ImageModel {
  ref: string;
  name: string;
  imageUrl?: string;
  versions?: ImageModelVersion[];
}

export const DEFAULT_IMAGE_MODEL: ImageModel = {
  ref: "https://civitai.red/models/2026594/miaomiao-realskin",
  name: "MiaoMiao RealSkin"
};

export function normalizeImageModelRef(ref: string | null | undefined): string {
  return ref?.trim() || DEFAULT_IMAGE_MODEL.ref;
}

// 服务端目录是唯一图片来源。仅未筛选目录保留默认项；搜索/tag 结果必须忠实反映服务端筛选。
export function mergeImageModels(catalog: ImageModel[], includeDefault = true): ImageModel[] {
  const unique = new Map<string, ImageModel>();
  for (const model of catalog) {
    if (model.ref.trim() && model.name.trim() && !unique.has(model.ref)) unique.set(model.ref, model);
  }
  const defaultFromCatalog = unique.get(DEFAULT_IMAGE_MODEL.ref);
  if (!includeDefault) return [...unique.values()];
  unique.delete(DEFAULT_IMAGE_MODEL.ref);
  return [defaultFromCatalog ?? DEFAULT_IMAGE_MODEL, ...unique.values()];
}

export function findImageModel(catalog: ImageModel[], ref: string): ImageModel {
  const directMatch = catalog.find((model) => model.ref === ref);
  if (directMatch) return directMatch;
  for (const model of catalog) {
    const version = model.versions?.find((candidate) => candidate.ref === ref);
    if (version) {
      const matchedModel = { ...model, ref: version.ref, name: version.name ? `${model.name} · ${version.name}` : model.name };
      return version.imageUrl ? { ...matchedModel, imageUrl: version.imageUrl } : matchedModel;
    }
  }
  return ref === DEFAULT_IMAGE_MODEL.ref ? DEFAULT_IMAGE_MODEL : { ref, name: ref };
}
